import { MemoryRouter } from 'react-router-dom';
import { CollectionSection } from '../../js/components/CollectionSection';
import { jsx as _jsx } from "react/jsx-runtime";
export const SAMPLE_COLLECTION_IMAGE = 'https://git.hubteam.com/storage/user/5145/files/bf3ab6a2-1df6-4b7f-8494-5cd10479007b';
export default {
  title: 'CollectionSection',
  component: CollectionSection,
  decorators: [Story => /*#__PURE__*/_jsx(MemoryRouter, {
    children: /*#__PURE__*/_jsx(Story, {})
  })],
  parameters: {
    actions: {
      disable: true
    },
    backgrounds: {
      values: [{
        name: 'fill-surface-raised',
        value: '#F5F8FA'
      }],
      default: 'fill-surface-raised'
    }
  },
  args: {
    title: 'Collaboration and Project Management',
    description: "Explore tools with everything you'll need to help your team get in a groove",
    imageUrl: SAMPLE_COLLECTION_IMAGE,
    collectionSlug: 'collaboration-and-project-management',
    cards: [{
      name: 'Gmail',
      description: 'Connect Gmail to HubSpot',
      imageSrcSmall: 'https://cdn2.hubspot.net/hubfs/521324/App-Icon-1200x1200-gmail.png',
      listingHref: 'https://www.hubspot.com',
      providerName: 'Google'
    }, {
      name: 'Slack',
      description: 'Connect Slack to HubSpot',
      imageSrcSmall: 'https://f.hubspotusercontent20.net/hubfs/521324/__hs-marketplace__/Slack_Mark_Web-1.png',
      listingHref: 'https://www.hubspot.com',
      providerName: 'Slack'
    }, {
      name: 'Asana',
      description: 'Connect Asana to HubSpot',
      imageSrcSmall: 'https://521324.fs1.hubspotusercontent-na1.net/hubfs/521324/__hs-marketplace__/Asana-Dots-Coral-1-1.png',
      listingHref: 'https://www.hubspot.com',
      providerName: 'Asana'
    }, {
      name: 'Trello',
      description: 'Connect Trello to HubSpot',
      imageSrcSmall: 'https://f.hubspotusercontent20.net/hubfs/521324/blob-Nov-18-2020-01-27-27-16-PM.png',
      listingHref: 'https://www.hubspot.com',
      providerName: 'Atlassian'
    }, {
      name: 'Microsoft Teams',
      description: 'Connect Microsoft Teams to HubSpot',
      imageSrcSmall: 'https://f.hubspotusercontent20.net/hubfs/521324/__hs-marketplace__/Logo%20%7C%20Microsoft%20Teams-1.png',
      listingHref: 'https://www.hubspot.com',
      providerName: 'Microsoft'
    }, {
      name: 'Zoom',
      description: 'Connect Zoom to HubSpot',
      imageSrcSmall: 'https://f.hubspotusercontent20.net/hubfs/521324/__hs-marketplace__/Zoom%20-%20Camera-1.png',
      listingHref: 'https://www.hubspot.com',
      providerName: 'Zoom'
    }]
  }
};
export const Basic = {};